import { render, staticRenderFns } from "./card-listing.vue?vue&type=template&id=5b8c4abb"
import script from "./card-listing.vue?vue&type=script&lang=js"
export * from "./card-listing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports